import { render } from "./account-pages-right-nav.vue?vue&type=template&id=605f8c80&ts=true"
import script from "./account-pages-right-nav.vue?vue&type=script&lang=ts"
export * from "./account-pages-right-nav.vue?vue&type=script&lang=ts"

import "./account-pages-right-nav.vue?vue&type=style&index=0&id=605f8c80&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__